var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author Vahagn Lazyan.
 * @since 2.1.0
 */
import { NgModule } from '@angular/core';
import { DeControlsModule } from '@synisys/idm-de-service-client-js';
import { DynamicFormControlsModule } from '@synisys/idm-dynamic-forms-controls';
import { ControlsModule, ControlsTranslationService, MessageService as NgControlsMessageService, } from '@synisys/idm-ng-controls';
import { DePermissionGuard, LockGuard, OnlineDePermissionGuard, OnlineLockGuard, } from '../service/guards';
import { OfflineDynamicFormsUiModule } from './offline-dynamic-forms-ui.module';
import { WarningOnLeaveGuard } from '../service/guards/impl/warning-on-leave.guard';
import { ConformationDialogComponent } from '../service/guards/impl/conformation-dialog.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatDialogModule } from '@angular/material';
import { MessageService } from '@synisys/idm-message-language-service-client-js';
var DynamicFormsUiModule = /** @class */ (function () {
    function DynamicFormsUiModule() {
    }
    DynamicFormsUiModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                ControlsModule,
                DeControlsModule,
                DynamicFormControlsModule,
                OfflineDynamicFormsUiModule,
                MatDialogModule,
                MatButtonModule,
            ],
            declarations: [ConformationDialogComponent],
            entryComponents: [ConformationDialogComponent],
            providers: [
                WarningOnLeaveGuard,
                ControlsTranslationService,
                { provide: NgControlsMessageService, useExisting: MessageService },
                { provide: DePermissionGuard, useClass: OnlineDePermissionGuard },
                { provide: LockGuard, useClass: OnlineLockGuard },
            ],
        })
    ], DynamicFormsUiModule);
    return DynamicFormsUiModule;
}());
export { DynamicFormsUiModule };
//# sourceMappingURL=dynamic-forms-ui.module.js.map